import axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { partner_Admin } from "../../../Configuration/Partner_URL";
import { decryptData, encryptData, mobileVal, onlyNumber, validatePan } from "../../../CommonMethhods/CommonMethods";
import { professionList } from "../ProfessionList";
import { toast } from "react-toastify";
import SmallLoader from "../../Common/smallLoader";

function PartnerPersonalData(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const  partnerDetails= props.partnerDetails;
  const id = props.id;
  const getPartnerId = props.getPartnerId;
  const errorMsg = props.errorMsg;
  const [perDetailsModal, setPerDetailsModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [panVal, setPanVal] = useState("");
  const [nameVal, setNameVal] = useState("");
  const [partnerCodeVal, setPartnerCodeVal] = useState("")
  const [mobVal, setMobVal] = useState("");
  const [sapCodeVal, setSapCodeVal] = useState("");
  const [emailVal, setEmailVal] = useState("");
  const [aadharVal, setAadharVal] = useState("");
  const [professionVal, setProfessionVal] = useState("");
  const [profData, setProfData] = useState("");
  const [pinCodeVal, setPinCodeVal] = useState("");
  const [stateVal, setStateVal] = useState("");
  const [cityVal, setCityVal] = useState("");
  const [addressVal, setAddressVal] = useState("");
  const [addressVal2, setAddressVal2] = useState("");
  const [revenueVal, setRevenueVal] = useState("");

  const updatePartnerData = async () => {
    
    setLoader(true);
    let payloadReq = {
      id: partnerDetails?.id,
      nameOnPan: nameVal?.length > 0 ? nameVal : partnerDetails?.nameOnPan,
      sapCode: sapCodeVal?.length > 0 ? sapCodeVal : partnerDetails?.sapCode,
      partnerCode: partnerCodeVal?.length > 0 ? partnerCodeVal : partnerDetails?.partnerCode,
      mobile: mobVal?.length > 0 ? mobVal : partnerDetails?.mobile,
      pan: panVal?.toUpperCase()?.length > 0 ? panVal?.toUpperCase() : partnerDetails?.pan,
      email: emailVal?.length> 0 ? emailVal : partnerDetails?.email,
      aadharNumber: aadharVal?.length > 0 ? aadharVal : partnerDetails?.aadharNumber,
      profession: professionVal?.length > 0 ? parseInt(professionVal) : partnerDetails?.profession,
      pincode: pinCodeVal?.length > 0 ? pinCodeVal : partnerDetails?.pincode,
      state: stateVal?.length > 0 ? stateVal : partnerDetails?.state,
      city: cityVal?.length > 0 ? cityVal: partnerDetails?.city,
      address: addressVal?.length > 0 ? addressVal: partnerDetails?.address,
      address2: addressVal2?.length > 0 ? addressVal2 : partnerDetails?.address2,
      revenueSharing: revenueVal?.length > 0 ? revenueVal : partnerDetails?.revenueSharing
  }

  let payloadApproved = encryptData(JSON.stringify(payloadReq));
    try {
      const getDetail = await axios.put(partner_Admin.GetPartnerById,
        payloadApproved,
        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${storeToken}`,
          },
        }
      );
      const res = decryptData(getDetail?.data);
      let decryptedRes = JSON.parse(res);
      if(decryptedRes?.status === 0){
      setPerDetailsModal(false)
      getPartnerId();
      toast.success(decryptedRes?.data?.message);
      }else{
        toast.error(decryptedRes?.data?.message);
      }
      
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong")
    }
    finally {
      setLoader(false);
    }
  };

  const professionData=()=>{

    professionList && professionList.map((item) => {
      if(partnerDetails?.profession === item?.ID){
         setProfData(item?.Profession)
      }
    })
  }

  useEffect(()=>{
    professionData();
  }, [partnerDetails?.profession]);
  

  const handleSaveBtn= ()=>{
    updatePartnerData();
    professionData();
    // getPartnerId();
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("Text");
    const onlyNumbers = pastedData.replace(/\D/g, "");
    setMobVal(onlyNumbers);
  };

 const handleEmailInput =  (e) => {
    let value = e.target.value;
    value = value.replace(/[^a-zA-Z0-9@.]/g, "");

    if (/^[@.]/.test(value)) {
      value = value.substring(1);
    }
    const atParts = value.split("@");
  if (atParts.length > 2) {
    value = atParts[0] + "@" + atParts.slice(1).join("").replace(/@/g, "");
  }
    value = value.replace(/\.{2,}/g, ".");
    value = value.replace(/\.@/, "@");
    value = value.replace(/@\.{1}/, "@");
    value = value.slice(0, 35);
    e.target.value = value;
    setEmailVal(value);
  };

  const handlePanPaste = (e) => {
    e.preventDefault();

    const pastedText = e.clipboardData.getData("text").toUpperCase().trim();
    const cleanText = pastedText.replace(/[^A-Za-z0-9]/g, "").slice(0, 10);
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

    if (panRegex.test(cleanText)) {
      setPanVal(cleanText);
    } else {
      console.warn("Invalid PAN format pasted");
    }
  };

  const handlePasteAddress = (fieldName) => (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text");
    let clean = pastedText
    .toUpperCase()
    .replace(/[^A-Z0-9#\/\-&.,\s]/g, "")
    .replace(/\s{2,}/g, " ")            
    .replace(/^\s+/, "")                
    .slice(0, 50);
    if (clean === "") return;
    const input = e.target;
    const start = input.selectionStart;
    const end = input.selectionEnd;
    const currentValue = input.value;
    const newValue = (
      currentValue.slice(0, start) +
      clean +
      currentValue.slice(end)
    ).slice(0, 50);
    if(fieldName === "address1"){
      setAddressVal(newValue)
    }else{
      setAddressVal2(newValue)
    }
    // setValue(fieldName, newValue, { shouldValidate: true });
    input.value = newValue;
    const cursorPos = Math.min(start + clean.length, 50);
    setTimeout(() => input.setSelectionRange(cursorPos, cursorPos), 0);
  };

  const onboardDate= partnerDetails?.onboardDate?.split("T")[0];

  return (
    <>
      <div className="card-box personal-details bottom-25">
        <div className="personal-details-top card-title">
          <h3>Personal Details</h3>
          {errorMsg?.length > 0 ? ""
          :
          <span className="icon-Edit" onClick={()=>setPerDetailsModal(true)}></span>
          }
        </div>
        <div className="personal-detail-boxes">
          <div className="personal-detail-boxes-item">
            <div className="boxes-item-top">
              <p className="item-label">Onboard Date</p>
              <span className="item-value">{onboardDate?.split("-").reverse()?.join("-") || "-"}</span>
            </div>
            <div className="boxes-item-bottom">
              <p className="item-label">Profession</p>
              <span className="item-value">{profData?.length > 0 ? profData : 
              partnerDetails?.profession || "-"}</span>
            </div>
          </div>
          <div className="personal-detail-boxes-item">
            <div className="boxes-item-top">
              <p className="item-label">PAN</p>
              <span className="item-value">{partnerDetails?.pan || "-"}</span>
            </div>
            <div className="boxes-item-bottom">
              <p className="item-label">Address</p>
              <span className="item-value">
                {partnerDetails?.address || "-"}
              </span>
            </div>
          </div>
          <div className="personal-detail-boxes-item">
            <div className="boxes-item-top">
              <p className="item-label">Email</p>
              <span className="item-value">{partnerDetails?.email || "-"}</span>
            </div>
            <div className="boxes-item-bottom">
              <p className="item-label">City</p>
              <span className="item-value">{partnerDetails?.city || "-"}</span>
            </div>
          </div>
          <div className="personal-detail-boxes-item">
            <div className="boxes-item-top">
              <p className="item-label">Aadhar</p>
              <span className="item-value">{partnerDetails?.aadharNumber || "0"}</span>
            </div>
            <div className="boxes-item-bottom">
              <p className="item-label">Pincode</p>
              <span className="item-value">{partnerDetails?.pincode || "0"}</span>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={perDetailsModal}
        size="lg"
        // aria-labelledby="contained-modal-title-vcenter"
        top-right
        className="per-modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title id="contained-modal-title-vcenter">
            {/* <div className="figure-inlac"> */}
            <h2 className="modal-title">Personal Details</h2>
            {/* </div> */}
          </Modal.Title>
          {/* <button type="button" className="btn-close" aria-label="Close" > */}
            <span className="icon-close" onClick={()=>setPerDetailsModal(false)}></span>
          {/* </button> */}
        </Modal.Header>
        <Modal.Body>
          <div>
            {/* <form onSubmit={()=>handleSaveBtn()}> */}
              <div className="row">
                <div className="col-md-6 col-12">
                  <div className="form-group">
                    <label className="form-label">Full Name</label>
                    <input
                      type="text"
                      name="search-text"
                      className="input-st"
                      placeholder="Full Name"
                      autoComplete="off"
                      disabled
                      onChange={(e)=>setNameVal(e?.target?.value)}
                      defaultValue={partnerDetails?.nameOnPan ? partnerDetails?.nameOnPan : nameVal}
                      onInput={(e) => {
                  const start = e.target.selectionStart;
                  const end = e.target.selectionEnd;

                  let input = e.target.value.toUpperCase();
                  input = input.replace(/[^a-zA-Z0-9 ]/g, "");
                          input = input.replace(/\s{2,}/g, " "); 
                          input = input.replace(/^\s+/, ""); 

                  if (input.length > 100) input = input.slice(0, 100);
                  e.target.value = input;
                  e.target.setSelectionRange(start, end);
                }}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="form-group calendar-icon">
                    <label className="form-label">Partner Code</label>
                    <input
                      type="text"
                      placeholder="Partner Code"
                      className="input-st"
                      disabled
                      onChange={(e)=>setPartnerCodeVal(e?.target?.value)}
                      onInput={(e) => {
                  const start = e.target.selectionStart;
                  const end = e.target.selectionEnd;

                  let input = e.target.value.toUpperCase();
                  input = input.replace(/[^a-zA-Z0-9 ]/g, "");
                          input = input.replace(/\s{2,}/g, " "); 
                          input = input.replace(/^\s+/, ""); 

                  if (input.length > 100) input = input.slice(0, 100);
                  e.target.value = input;
                  e.target.setSelectionRange(start, end);
                }}
                      defaultValue={partnerDetails?.partnerCode ? partnerDetails?.partnerCode : partnerCodeVal}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="form-group">
                    <label className="form-label">SAP Code</label>
                    <input
                      type="text"
                      className="input-st"
                      placeholder="SAP Code"
                      autoComplete="off"
                      onChange={(e)=> setSapCodeVal(e?.target?.value)}
                      onInput={(e) => {
                        const start = e.target.selectionStart;
                        const end = e.target.selectionEnd;

                        let input = e.target.value.toUpperCase();
                        input = input.replace(/[^a-zA-Z0-9 ]/g, "");
                                input = input.replace(/\s{2,}/g, " "); 
                                input = input.replace(/^\s+/, ""); 

                        if (input.length > 50) input = input.slice(0, 50);
                        e.target.value = input;
                        e.target.setSelectionRange(start, end);
                      }}
                      defaultValue={partnerDetails?.sapCode ? partnerDetails?.sapCode : sapCodeVal}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="form-group">
                    <label className="form-label">Phone</label>
                    <input
                      type="text"
                      className="input-st"
                      maxLength={10}
                      placeholder="Phone"
                      autoComplete="off"
                      onChange={(e)=>setMobVal(e.target.value)}
                      defaultValue={partnerDetails?.mobile ? partnerDetails?.mobile : mobVal}
                      onKeyPress={(e) => mobileVal(e)}
                      onPaste={handlePaste}

                    />
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="form-group">
                    <label className="form-label">Email</label>
                    <input
                      type="text"
                      name="search-text"
                      className="input-st"
                      placeholder="Email"
                      autoComplete="off"
                      onInput={handleEmailInput}
                      // onChange={(e)=> setEmailVal(e?.target?.value)}
                      defaultValue={partnerDetails?.email ? partnerDetails?.email : emailVal}

                    />
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="form-group">
                    <label className="form-label">PAN</label>
                    <input
                      type="text"
                      maxLength={10}
                      name="search-text"
                      className="input-st text-uppercase"
                      placeholder="PAN"
                      autoComplete="off"
                      disabled
                      onKeyPress={(e)=>validatePan(e)}
                      // onChange={(e)=> setPanVal(e?.target?.value)}
                      onChange={(e) => {
                      const start = e.target.selectionStart;
                      const end = e.target.selectionEnd;

                      let input = e.target.value
                      input = input
                        .toUpperCase()
                        .replace(/[^A-Z0-9]/gi, "")
                        .trimStart()
                        .slice(0, 10);

                      e.target.value = input;
                        setPanVal(input)
                      e.target.setSelectionRange(start, end);
                    }}
                    onPaste={handlePanPaste}
                      defaultValue={partnerDetails?.pan ? partnerDetails?.pan : panVal}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="form-group">
                    <label className="form-label">Aadhar</label>
                    <input
                      type="text"
                      name="search-text"
                      maxLength={12}
                      className="input-st"
                      placeholder="Aadhar"
                      autoComplete="off"
                      onChange={(e)=> setAadharVal(e?.target?.value)}
                      defaultValue={partnerDetails?.aadharNumber ? partnerDetails?.aadharNumber : aadharVal}

                    />
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="form-group type-select">
                    <label className="form-label">Profession</label>
                    
                    <select onChange={(e)=>setProfessionVal(e?.target?.value)} 
                      defaultValue={partnerDetails?.profession ? partnerDetails?.profession : professionVal}>
                        
                      {professionList && professionList.map((item) => {
                        
                          return <option value={item?.ID}>{item?.Profession}</option>

                      })
                      
                      } 
                    </select>
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="form-group">
                    <label className="form-label">Pincode</label>
                    <input
                      type="text"
                      className="input-st"
                      maxLength={6}
                      onInput={onlyNumber}
                      placeholder="Pincode"
                      autoComplete="off"
                      onChange={(e)=> setPinCodeVal(e?.target?.value)}
                      defaultValue={partnerDetails?.pincode ? partnerDetails?.pincode : pinCodeVal}
                    />
                  </div>
                </div>

                <div className="col-md-6 col-12">
                  <div className="form-group type-select">
                    <label className="form-label">State</label>
                    <select>
                      <option onChange={(e)=> setStateVal(e?.target?.value)}
                      defaultValue={partnerDetails?.state ? partnerDetails?.state : stateVal}>
                        {partnerDetails?.state ? partnerDetails?.state : stateVal}</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="form-group">
                    <label className="form-label">City</label>
                    <input
                      type="text"
                      name="search-text"
                      className="input-st"
                      placeholder="City"
                      autoComplete="off"
                      onChange={(e)=> setCityVal(e?.target?.value)}
                      defaultValue={partnerDetails?.city ? partnerDetails?.city : cityVal}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="form-group">
                    <label className="form-label">Revenue Sharing</label>
                    <input
                      type="text"
                      name="search-text"
                      className="input-st"
                      placeholder="Revenue Sharing"
                      autoComplete="off"
                      onChange={(e)=>setRevenueVal(e?.target?.value)}
                      defaultValue={partnerDetails?.revenueSharing ? partnerDetails?.revenueSharing : revenueVal}
                    />
                  </div>
                </div>
                <div className="col-md-12 col-12">
                  <div className="form-group">
                    <label className="form-label">Address Line 1</label>
                    <input
                      type="text"
                      name="search-text"
                      className="input-st"
                      placeholder="Address Line 1"
                      autoComplete="off"
                      onPaste={handlePasteAddress("address1")}
                      // onChange={(e)=> setAddressVal(e?.target?.value)}
                      onChange={(e) => {
                        const start = e.target.selectionStart;
                        const end = e.target.selectionEnd;

                        let input = e.target.value.toUpperCase();
                        input = input.replace(/[^A-Z0-9#\/\-&.,\s]/g, "");
                                input = input.replace(/\s{2,}/g, " "); 
                                input = input.replace(/^\s+/, ""); 

                        if (input.length > 50) input = input.slice(0, 50);
                        e.target.value = input;
                        setAddressVal(input)
                        e.target.setSelectionRange(start, end);
                      }}
                      defaultValue={partnerDetails?.address ? partnerDetails?.address : addressVal}

                    />
                  </div>
                </div>
                <div className="col-md-12 col-12">
                  <div className="form-group">
                    <label className="form-label">Address Line 2</label>
                    <input
                      type="text"
                      name="search-text"
                      className="input-st"
                      placeholder="Address Line 2"
                      autoComplete="off"
                      onPaste={handlePasteAddress("address2")}
                      // onChange={(e)=> setAddressVal2(e?.target?.value)}
                      onChange={(e) => {
                        const start = e.target.selectionStart;
                        const end = e.target.selectionEnd;

                        let input = e.target.value.toUpperCase();
                        input = input.replace(/[^A-Z0-9#\/\-&.,\s]/g, "");
                                input = input.replace(/\s{2,}/g, " "); 
                                input = input.replace(/^\s+/, ""); 

                        if (input.length > 50) input = input.slice(0, 50);
                        e.target.value = input;
                        setAddressVal2(input)
                        e.target.setSelectionRange(start, end);
                      }}
                      defaultValue={partnerDetails?.address2 ? partnerDetails?.address2 : addressVal2}
                    />
                  </div>
                </div>
              </div>

              <button 
              className="save-changes signup-btn"  
              type="submit" 
              onClick={()=>handleSaveBtn()}
              >
                {loader ? 
                  <SmallLoader />
                  : 
                  <>
                    Save Changes
                  </>
                }
              </button>
            {/* </form> */}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default PartnerPersonalData;
